import { DemoComunityListObject } from "assets/data/communities";
import { Link } from "react-router-dom";
import { SVG } from "ui";
import { CustomComponentProps } from "utils/types/general.types";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { blockedPNG, deletedPNG } from "utils/assets_exports/images";
import { shortUserName } from "utils/helpers/shortUserName";

export type CommunityListProps = CustomComponentProps & {
    listItem: DemoComunityListObject;
    handleDelete: (id: string | number) => void;
    handleBlock: (id: string | number) => void;
    handleRestore: (id: string | number) => void;
    handleSendMsg: (group: DemoComunityListObject) => void;
};

// const items: string[] = ["View", "Block", "Delete"];

const CommunityList = ({
    listItem,
    handleBlock,
    handleDelete,
    handleRestore,
    handleSendMsg,
    className,
    style
}: CommunityListProps) => {
    // const [selected, setSelected] = useState("");

    return (
        <div
            className={`community-list column is-4 ${className}`}
            style={style}
        >
            <article className="group-box dark:text-white">
                <div className="box-info-hover">
                    {/* <i data-feather="heart"></i> */}
                    <div className="box-clock-info flex justify-center items-center gap-1">
                        <SVG
                            svg="topics"
                            className="cursor-default"
                            size={16}
                        />
                        <span className="box-time">
                            {listItem.newPosts} new
                        </span>
                    </div>
                    <div className={`my-drop-down relative w-fit`}>
                        {/* <div> */}
                        <MoreVertIcon
                            fontSize="medium"
                            className="my-drop-down-more-vertical dark:text-white"
                        />
                        {/* </div> */}
                        <div
                            className={`my-drop-down-div right bg-neutral-100 dark:bg-momeento-300 rounded`}
                        >
                            <ul>
                                <li
                                    className={`my-drop-down-item dark:text-white rounded`}
                                >
                                    <Link
                                        to={`/communities/view/${listItem.id}`}
                                        className="w-full block"
                                    >
                                        View
                                    </Link>
                                </li>
                                <li
                                    className={`my-drop-down-item dark:text-white rounded`}
                                    onClick={() => {
                                        if (listItem.status === "blocked") {
                                            handleRestore(listItem.id);
                                        } else {
                                            handleBlock(listItem.id);
                                        }
                                    }}
                                >
                                    {listItem.status === "blocked"
                                        ? "Unblock"
                                        : "Block"}
                                </li>
                                <li
                                    className={`my-drop-down-item dark:text-white rounded`}
                                    onClick={() => {
                                        if (listItem.status === "deleted") {
                                            handleRestore(listItem.id);
                                        } else {
                                            handleDelete(listItem.id);
                                        }
                                    }}
                                >
                                    {listItem.status === "deleted"
                                        ? "Restore"
                                        : "Delete"}
                                </li>
                                <li
                                    className={`my-drop-down-item dark:text-white rounded`}
                                    onClick={() => handleSendMsg(listItem)}
                                >
                                    Message
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div
                    className="box-img has-background-image"
                    style={{
                        backgroundImage: `url('${listItem.img}')`
                    }}
                ></div>
                <div className="box-link">
                    <div
                        className="box-img--hover has-background-image"
                        style={{
                            backgroundImage: `url('${listItem.img}')`
                        }}
                    >
                        {listItem.status !== "active" && (
                            <div
                                className="absolute top-0 left-0 w-full h-full"
                                style={{
                                    background: "rgba(0,0,0,0.5)",
                                    borderRadius: "0.75rem 0.75rem 0 0 "
                                }}
                            >
                                {listItem.status === "blocked" && (
                                    <img
                                        src={blockedPNG}
                                        alt="blocked badge"
                                        className="absolute top-5 left-5 shadow-xl z-2 w-1/2 h-auto"
                                    />
                                )}
                                {listItem.status === "deleted" && (
                                    <img
                                        src={deletedPNG}
                                        alt="blocked badge"
                                        className="absolute top-5 left-5 shadow-xl z-2 w-1/2 h-auto"
                                    />
                                )}
                            </div>
                        )}
                        <Link
                            to={`/communities/view/${listItem.id}`}
                            className="w-full h-full block absolute z-3"
                        ></Link>
                    </div>
                </div>
                <div className="box-info" style={{ height: "150px" }}>
                    <span className="box-category break-words">
                        {listItem.id}
                    </span>
                    <h3 className="box-title white-text">
                        <Link to={`/communities/view/${listItem.id}`}>
                            {shortUserName(listItem.title, 30)}
                        </Link>
                    </h3>
                    <span className="box-members">
                        <Link to={`/communities/view/${listItem.id}/members`}>
                            {listItem.members} members
                        </Link>
                    </span>
                </div>
            </article>
            {listItem.status !== "active" && (
                <div className="flex mt-3 justify-center">
                    <button
                        className="px-5 py-1 bg-momeento-50 hover:shadow-lg focus:shadow-lg text-white rounded-full"
                        onClick={() => handleRestore(listItem.id)}
                    >
                        restore
                    </button>
                </div>
            )}
        </div>
    );
};

export default CommunityList;
